export const INFORMATION_DATA = [
  {
    type: "aboutUS",
    heading: "ABOUT US",
    intro: `
      Welcome to "Seed To Tree," where growth is a journey and learning,
      like a seed becoming a tree. We examine the similarities between seed
      growth and human development. Shedding emphasizes the intricacies of
      both natural and personal progress.
    `,
    sections: [
      {
        title: "Our Journey",
        content: `
          Three years ago, the name "Seed To Tree" was born from a deep analogy,
          a valuable insight from my mother's wisdom. The name underscores the
          dedication needed to foster growth, akin to tending a garden.
        `,
      },
      {
        title: "Our Commitment",
        content: `
          At Seed to Tree Academy, our commitment to excellence in education is
          unwavering. We believe in sowing the seeds of knowledge, nurturing
          curiosity, and cultivating a love for learning in every person who walks
          through our doors.
        `,
      },
      {
        title: "Our Approach",
        content: `
          We provide a nurturing environment that fosters creativity, critical
          thinking, and a sense of community. Our curriculum goes beyond textbooks,
          incorporating real-world experiences and hands-on learning, preparing our
          students for a future full of opportunities.
        `,
      },
      {
        title: "Our Achievements",
        content: `
          In just three years, Seed to Tree Academy has achieved remarkable
          milestones. Our students have consistently excelled academically, and our
          alumni have gone on to prestigious educational institutions and
          successful careers.
        `,
      },
      {
        title: "Our Vision",
        content: `
          As we look ahead, our vision remains clear - to continue nurturing young
          minds and inspiring them to reach new heights. Seed to Tree Academy is
          committed to evolving with the times, incorporating cutting-edge
          educational practices, and providing an environment where everyone can
          thrive and grow into responsible, compassionate, and innovative global
          citizens.
        `,
      },
      {
        title: "Our Mission",
        content: `
          At Seed to Tree Online Academy, we're not just cultivating knowledge; we're nurturing dreams, fostering growth, and sowing the seeds of success. Join us, and let's flourish together!
        `,
      },
    ],
  },
  {
    type: "joinUS",
    heading: "JOIN US",
    intro: `
      Seed to Tree Online Academy is your gateway to a world of limitless possibilities in education. Whether you're a curious student eager to expand your horizons, a passionate teacher looking to inspire the next generation, or a lifelong learner seeking growth, our academy is the perfect choice.
    `,
    sections: [
      {
        title: "As a Student",
        content: `
          You'll find a diverse range of courses taught by experts that cater to your unique learning style. Our commitment to innovation ensures you have access to cutting-edge resources, making your learning journey both engaging and rewarding.
        `,
      },
      {
        title: "For Teachers and Members",
        content: `
          If you're a teacher or member, our academy provides an exceptional platform to share your knowledge and expertise with a global community. We foster collaboration, creativity, and continuous improvement, empowering you to make a meaningful impact on learners worldwide.
        `,
      },
    ],
  },
  {
    type: "contactUS",
    email: "seedtotree.info@gmail.com",
    phone: ["+923405021470"],
    address: "Islamabad, Pakistan",
  },
];

// Function to retrieve data by type
function getInformationByType(data, type) {
  return data.find((item) => item.type === type) ;
}

// Usage
export const CONTACTUS_Data = getInformationByType(
  INFORMATION_DATA,
  "contactUS"
);
export const ABOUTUS_Data = getInformationByType(
  INFORMATION_DATA,
  "aboutUS"
);
export const JOINUS_Data = getInformationByType(
  INFORMATION_DATA,
  "joinUS"
);
